import { SectionPageHeader } from '@ingenico/react-section-utils';
import type { ReactElement } from 'react';
import { useResourcesPageVM } from './useResourcesPage.vm';
import { ResourcesList } from '../../components/resources-list/ResourcesList.ctrl';
import { CreateResourceModal } from '../../components/create-resource-modal/CreateResourceModal.ctrl';

export function ResourcesPage(): ReactElement {
  const { isMobile, canCreate, createButton, resourcesListVM, handleResourceCreated, pageSubtitle, pageTitle } =
    useResourcesPageVM();

  return (
    <>
      {!isMobile && (
        <SectionPageHeader rightContent={canCreate ? createButton : null} subtitle={pageSubtitle} title={pageTitle} />
      )}
      <ResourcesList resourcesListVM={resourcesListVM} />
      {canCreate ? <CreateResourceModal onCreated={handleResourceCreated} /> : null}
    </>
  );
}
